// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__3GqzW","withMobileMargins":"DateRangeInput_withMobileMargins__1paTK","arrowIcon":"DateRangeInput_arrowIcon__kyA9E"};